import React from "react";
import PublicLayout from "../layouts/PublicLayout";
import Login from "../components/pages/user/Login";
import ConfitmOtp from "../components/pages/user/ConfirmOtp";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "../layouts/Dashboard";
import User from "../components/pages/user/User";
import AdminLayout from "../layouts/AdminLayout";
import SeoLayout from "../layouts/SeoLayout";
import Configuration from "../components/pages/configurations/Configuration";
import AddConfiguration from "../components/pages/configurations/AddConfiguration";
import TourAndPackages from "../components/package/TourAndPackages";
import ManageAirportDestinationsList from "../components/airportDestinations/ManageAirportDestinationsList";
import AddManageAirportDestinations from "../components/airportDestinations/AddManageAirportDestinations";
import PackageList from "../components/package/PackageList";
import CategoryList from "../components/package/CategoryList";
import AddCategory from "../components/package/AddCategory";
import DestinationsList from "../components/package/DestinationsList";
import Adddestination from "../components/package/Adddestination";
import PopularAirPortDestination from "../components/airportDestinations/PopularAirPortDestination";
import Coupons from "../components/pages/Coupons";
import AddCoupons from "../components/pages/AddCoupons";
import AddPopularAirportDestination from "../components/airportDestinations/AddPopularAirPortDestination";
import HolidayBookings from "../layouts/HolidayBookings";
import FlightBookings from "../components/pages/transaction/Booking";
import ManageHotelCityList from "../components/hotel/ManageHotelCityList";
import AddHotelCityMetaData from "../components/hotel/AddHotelCityMetaData";
import AddFeedback from "../components/package/AddFeedback";
import Feedbacks from "../components/package/Feedbacks";
import AddOffersManagementPage from "../components/offerspages/AddOffersManagementPage";
import OffersManagementList from "../components/offerspages/OffersManagementList";
import AddFlightBanner from "../components/banners/addFlightBanner";
import FlightBannersList from "../components/banners/FlightBannerList";


const SeoRouter = () => {

  return (
    <div>
      <Router>
        <Routes>
          <Route element={<SeoLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/flight-bookings" element={<FlightBookings />} />
            <Route path="/coupons" element={<Coupons />} />
            <Route path="/add-coupons" element={<AddCoupons />} />
            <Route path="/edit-coupons/:id" element={<AddCoupons />} />
            {/* <Route path="/hotel-bookings" element={<HotelBookings />} /> */}
            <Route path="/holiday-bookings" element={<HolidayBookings />} />

            {/* <Route path="/configurations" element={<Configuration />} />
            <Route path="/add-configuration" element={<AddConfiguration />} />
            <Route path="/edit-configuration/:id" element={<AddConfiguration />} /> */}
            <Route path="/add-tour-and-packages" element={<TourAndPackages />} />
            <Route path="/manage-airport-destinations-list" element={<ManageAirportDestinationsList />} />
            <Route path="/add-manage-airport-destinations" element={<AddManageAirportDestinations />} />
            <Route path="/edit-manage-airport-destinations/:id" element={<AddManageAirportDestinations />} />
            <Route path="/edit-package/:id" element={<TourAndPackages />} />
            <Route path="/package-list" element={<PackageList />} />
            <Route path="/category-list" element={<CategoryList />} />
            <Route path="/add-category" element={<AddCategory />} />
            <Route path="/edit-category/:id" element={<AddCategory />} />
            <Route path="/destination-list" element={<DestinationsList />} />
            <Route path="/add-destination" element={<Adddestination />} />
            <Route path="/edit-destination/:id" element={<Adddestination />} />

            <Route path="/popular-airPort-destination" element={<PopularAirPortDestination />} />
            <Route path="/add-popular-airPort-destination" element={<AddPopularAirportDestination />} />
            <Route path="/edit-popular-airPort-destination/:id" element={<AddPopularAirportDestination />} />
            <Route path="/manage-hotel-city-list" element={<ManageHotelCityList />} />
            <Route path="/add-hotel-city-meta-data" element={<AddHotelCityMetaData />} />
            <Route path="/edit-hotel-city-meta-data/:id" element={<AddHotelCityMetaData />} />

            <Route path="/add-feedback" element={<AddFeedback />} />
            <Route path="/edit-feedback/:id" element={<AddFeedback />} />
            <Route path="/feedbacks" element={<Feedbacks />} />


            <Route path="/add-flight-banner" element={<AddFlightBanner />} />
            <Route path="/edit-flight-banner/:id" element={<AddFlightBanner />} />
            <Route path="/flight-banner" element={<FlightBannersList />} />

            <Route path="/add-offers-management" element={<AddOffersManagementPage />} />
            <Route path="/edit-offers-management/:id" element={<AddOffersManagementPage />} />
            <Route path="/offers-management-list" element={<OffersManagementList />} />


            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default SeoRouter;
